var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneWayTrip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 9.82718C17.6714 10.1233 17.5619 10.4071 17.3673 10.6161L10.6105 17.8766C10.2054 18.3118 9.5497 18.3107 9.14596 17.8739C8.74222 17.4372 8.74332 16.7303 9.1484 16.295L14.1335 10.9384L1.03415 10.9179C0.462219 10.917 -0.000749982 10.4164 7.97415e-05 9.79984C0.000907558 9.18323 0.465219 8.6841 1.03715 8.68499L14.1389 8.70544L9.14597 3.30451C8.74223 2.86778 8.74332 2.16088 9.1484 1.7256C9.55349 1.29031 10.2092 1.29149 10.6129 1.72822L17.3698 9.03718C17.5637 9.2469 17.6723 9.53108 17.6719 9.82718Z",
    fill: "#061556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneWayTrip);
export default __webpack_public_path__ + "static/media/OneWayTrip.0d7cea20ae5f7d2bce29251dc41fe982.svg";
export { ForwardRef as ReactComponent };